import React from "react";
import { Header } from "../components/Header";
import { Pricing } from "../components/Pricing";
import { ContactFooter } from "../components/ContactFooter";
import { PageBanner, PageHeading } from "../components/PageBanner";
import { useLanguage } from "../i18n";

export default function PricingPage() {
  const { t } = useLanguage();
  return (
    <div data-testid="pricing-page" className="min-h-screen bg-cream">
      <Header />
      <main>
        <PageHeading testid="pricing-heading" label={t.nav.pricing} />
        <PageBanner testid="pricing-banner" label={t.nav.pricing} video="/media/servizi-video.mp4" mid noCaption ratio="16 / 9" />
        {/* the page heading already says "Servizi", so the section label below the banner is not repeated */}
        <Pricing withCall hideOverline />
      </main>
      <ContactFooter />
    </div>
  );
}
